import type { ITransformRT3 } from '@seddi/math-v2';
import { Quaternion, Vector3 } from '@seddi/three';

import { type CameraLookAt, create as createLookAt } from './cameraLookAt';

export function computeCameraLookAtFromTransform(transform: ITransformRT3): CameraLookAt {
  const { translation, rotation } = transform;
  const res = createLookAt();
  // set origin
  res.origin.x = translation.x;
  res.origin.y = translation.y;
  res.origin.z = translation.z;
  // ray from rotation
  const q = new Quaternion(rotation.x, rotation.y, rotation.z, rotation.w);
  const v = new Vector3(0.0, 0.0, -1.0);
  v.applyQuaternion(q);
  // In the current implementation we compute the target as a 1m displacement in the camera view
  // TODO: compute target as closest point to Y axis line?
  res.target.x = res.origin.x + v.x;
  res.target.y = res.origin.y + v.y;
  res.target.z = res.origin.z + v.z;
  // compute distance
  res.distance = v.copy(res.origin).distanceTo(res.target);
  return res;
}
